import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "relative inline-block border rounded-full border-neutral-400 hover:bg-gray-100" }
const _hoisted_2 = {
  key: 1,
  class: "inline-flex items-center justify-center w-4 h-4 text-[10px] font-bold rounded-full bg-primary30 text-white"
}
const _hoisted_3 = { class: "flex flex-col gap-3" }
const _hoisted_4 = { class: "flex flex-col gap-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "text-xs text-gray-500 font-medium" }, "Valor mínimo (R$)", -1)
const _hoisted_6 = { class: "flex flex-col gap-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "text-xs text-gray-500 font-medium" }, "Valor máximo (R$)", -1)

import { ref, computed, type Component } from 'vue'

export interface ValueRange {
  min: number | undefined
  max: number | undefined
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ValueRangeFilter',
  props: {
    label: {},
    icon: {},
    isOpen: { type: Boolean }
  },
  emits: ["select"],
  setup(__props: any, { expose: __expose, emit }) {





const localMin = ref<number | undefined>(undefined)
const localMax = ref<number | undefined>(undefined)

const hasActiveFilter = computed(() => localMin.value !== undefined || localMax.value !== undefined)

function toggle() {
  // handled by parent via isOpen prop
}

function applyFilter() {
  emit('select', {
    min:
      localMin.value !== undefined && localMin.value !== null ? Number(localMin.value) : undefined,
    max:
      localMax.value !== undefined && localMax.value !== null ? Number(localMax.value) : undefined
  })
}

function reset() {
  localMin.value = undefined
  localMax.value = undefined
}

__expose({ reset })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      onClick: toggle,
      class: "flex items-center gap-2 px-4 py-2 text-sm text-neutral-400 rounded-full"
    }, [
      (_ctx.icon)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icon), {
            key: 0,
            class: "w-4 h-4"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("span", null, _toDisplayString(_ctx.label), 1),
      (hasActiveFilter.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, " 1 "))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
          class: "absolute z-10 mt-2 left-0 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 min-w-[260px] border border-neutral-200 p-4"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localMin).value = $event)),
                type: "number",
                min: "0",
                step: "0.01",
                placeholder: "0,00",
                class: "w-full px-3 py-1.5 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-primary"
              }, null, 512), [
                [_vModelText, localMin.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localMax).value = $event)),
                type: "number",
                min: "0",
                step: "0.01",
                placeholder: "0,00",
                class: "w-full px-3 py-1.5 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-primary"
              }, null, 512), [
                [_vModelText, localMax.value]
              ])
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "w-full py-1.5 text-sm font-medium text-white bg-primary30 rounded hover:opacity-90",
              onClick: applyFilter
            }, " Aplicar ")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})